export const VERSION_INFO = { tag: '2.86.0', branch: '2.86.0', commit: '9f6c7e9d13f62caed981bee8a06ab8b344848ced', date: 'Thu Mar 19 14:24:23 UTC 2026' }
